import { Home1 } from './Home1'
import { Home2 } from './Home2'
import { ShortcutDrawer } from './ShortcutDrawer'
import useGlobalModel from "@/model/globalModel";

export const HomeIndex = () => {

  const { isAdmin } = useGlobalModel();

  return (
    <>
      {isAdmin && <Home1 />}
      {!isAdmin && <Home2 />}
      <ShortcutDrawer />
    </>
  )
}